<ng-container *transloco="let t">
  @switch (state) {
    @case (UserState.ENABLED) {
      <span appearance="positive" tuiBadge tuiStatus>
        @if (count !== undefined) {
          {{ t('{count, plural, =0 {Actif : #} =1 {Actif : #} other {Actifs : #} }', { count }) }}
        } @else {
          {{ t('Actif') }}
        }
      </span>
    }
    @case (UserState.INVITED) {
      <span appearance="neutral" tuiBadge tuiStatus>
        @if (count !== undefined) {
          {{
            t(
              '{count, plural, =0 {Invitation envoyée : #} one {Invitation envoyée : #} other {Invitation envoyées : #} }',
              { count }
            )
          }}
        } @else {
          {{ t('Invitation envoyée') }}
        }
      </span>
    }
    @case (UserState.DISABLED) {
      <span appearance="warning" tuiBadge tuiStatus>
        @if (count !== undefined) {
          {{ t('{count, plural, =0 {Désactivé : #} =1 {Désactivé : #} other {Désactivés : #} }', { count }) }}
        } @else {
          {{ t('Désactivé') }}
        }
      </span>
    }
  }
</ng-container>
